export const YES_NO = {
  YES: 1,
  NO: 0
}

export const YES_NO2 = {
  YES: true,
  NO: false
}

export const WORKFLOW_APPROVAL_STATUS = {
  PASSED: 'PASSED',
  REFUSED: 'REFUSED',
  REJECTED: 'REJECTED',
  IN_APPROVE: 'IN_APPROVE'
}

export const WORKFLOW_APPROVAL_STATUS_IN_LIST = {
  INIT: 'INIT', // 驳回
  PROCESS: 'PROCESS', // 发起处理
  FAIL: 'FAIL', // 处理失败
  SUCCESS: 'SUCCESS' // 处理成功
}

export const WORKFLOW_PROCESS_TYPE = {
  CONFIG_FINANCE_INFO_APPROVAL: 'LC000764',
  FINANCE_WORKFLOW_DEFINATION: 'LC000770',
  FINANCE_ORDER_APPROVAL: 'LC000771',
  CHANGE_INFO_APPROVAL: 'LC000772',
  REPAYMENT_APPROVAL: 'LC000804',
  BALANCE_DISTRIBUTION_APPROVAL: 'LC000801',
  SUPPLIER_REFUND_APPROVAL: 'LC000809',
  PAYMENT_APPROVAL: 'LC000819',
  PAYMENT_BATCH_APPROVAL: 'LC000820',
  BUYER_PAYMENT_APPROVAL: 'LC000821'
}

export const FINANCE_PRODUCT_ID = {
  ARP_WITH_LIMITED_RECOURSE: '1', // 应收账款融资-无追索（装运后）
  ARP_WITH_RECOURSE: '2', // 应收账款融资-有追索（装运后）
  PRE_SHIPMENT_LOAN: '3', // 采购订单融资
  ARP_CONFIRMATION_RAISED_BEFORE_SHIPMENT: '4' // 应收账款融资承诺
}

export const ASSOCIATE_INVOICE_SOURCE_TYPE = {
  INFLOW_APPLY: 'INFLOW_APPLY',
  BATCH_REPAYMENT: 'BATCH_REPAYMENT'
}

export const INFLOW_METHOD = {
  AIR8_INFLOW: 'Air8_INFLOW',
  LEDGER: 'LEDGER'
}

export const IF_QUERY_VERSION = {
  YES: 'YES',
  NO: 'NO'
}

export const REFINITIV_SUBMIT_GENDER = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  UNSPECIFIED: 'UNSPECIFIED'
}

export const ALL_KEY = 'ALL'

export const ATTACHEMENT_OCR_TYPE = {
  COMPANY_BL: 'COMPANY_BL',
  PERSONAL_LICENSE: 'PERSONAL_LICENSE'
}

export const SHAREHOLDER_JOB = {
  DIRECTOR: 'DIRECTOR',
  SHAREHOLDER: 'SHAREHOLDER',
  LEGAL_REPRESENTATIVE: 'LEGAL_REPRESENTATIVE'
}

export const BANK_ACCT_STATUS = {
  ENABLE: 'ENABLE',
  DISABLE: 'DISABLE',
  PENDING_ACTIVATE: 'PENDING_ACTIVATE'
}

export const AGING_REPORT_COMPANY_ROLE = {
  SUPPLIER: 'SUPPLIER',
  BUYER: 'BUYER'
}

export const COMPANY_STATUS = {
  IN_KYC: 'IN_KYC'
}

export const MAX_PAGE_SIZE = 20000

export const REFINITIV_TYPE = {
  COMPANY: 'COMPANY',
  KEY_PERSON: 'KEY_PERSON',
  SHAREHOLDER_CORP: 'SHAREHOLDER_CORP'
}

export const NODE_ID = {
  START: '_START',
  END: '结束' // value is ID
}

export const YES_STRING = {
  YES: '1',
  NO: '0'
}

export const CATEGORY_OPTION_MAP = {
  CATEGORY_1: '1',
  CATEGORY_2: '2',
  CATEGORY_3: '3',
  CATEGORY_4: '4',
  CATEGORY_5: '5',
  CATEGORY_6: '6',
  CATEGORY_7: '7',
  CATEGORY_8: '8',
  CATEGORY_9: '9',
  CATEGORY_10: '10',
  CATEGORY_11: '11',
  CATEGORY_12: '12',
  CATEGORY_13: '13',
  CATEGORY_14: '14',
  CATEGORY_15: '15',
  CATEGORY_16: '16',
  CATEGORY_17: '17',
  CATEGORY_18: '18',
  CATEGORY_19: '19',
  CATEGORY_20: '20'
}

export const CHART_COLOR_LIST_4 = [
  '#1BB5B0', '#4A81FA', '#A86AD9', '#EBBD18', '#634BF4', '#E94E98', '#1892EB',
  '#F44B4B', '#36CF6A', '#F4A60F', '#D344EB', '#186CEB', '#0BCBA9', '#1778BF',
  '#1A4F75', '#1F7CED'
]

export const CHART_LINE_AREA_COLOR_STAR = [
  '#1bb5b066',
  '#4a81fa66',
  '#a86ad966',
  '#ebbd1866',
  '#634bf466',
  '#e94e9866',
  '#1892eb66',
  '#f44b4b66',
  '#36cf6a66',
  '#f4a60f66',
  '#d344eb66',
  '#186ceb66',
  '#0bcba966',
  '#1778bf66',
  '#1a4f7566',
  '#1f7ced66'
]

export const CHART_LINE_AREA_COLOR_END = [
  '#1bb5b000',
  '#4a81fa00',
  '#a86ad900',
  '#ebbd1800',
  '#634bf400',
  '#e94e9800',
  '#1892eb00',
  '#f44b4b00',
  '#36cf6a00',
  '#f4a60f00',
  '#d344eb00',
  '#186ceb00',
  '#0bcba900',
  '#1778bf00',
  '#1a4f7500',
  '#1f7ced00'
]

export const TITLE = {
  BD: 'BD'
}
